<template>
    <div class="photo-frame">
        <a :href="link" style="text-decoration: none; color: inherit;">
            <div class="photo-frame-inner-wrap">
                <div class="photo-frame-img" :style="{ 'background-image' : `url(${src})` }"></div>
                <div class="frame-blurb-wrap">
                    <p class="frame-blurb">{{text}}</p>
                </div>
                <div class="frame-meta" v-if="tags">
                    <p><fa-icon :icon="['fas', 'tag']"/> {{tags}}</p>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        name: "BlogCard",
        components: {

        },
        props: {
            link: String,
            src: String,
            tags: String,
            text: String
        },
        data () {
            return {
            } 
        },
        computed: {

        },
        methods: {

        }
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/variables";
    .photo-frame {
        min-width: 300px;
        max-width: 500px;
        margin-bottom: 20px;
        padding: 0 10px;
        justify-self: space-around;

        .photo-frame-inner-wrap {
            cursor: pointer;
            margin: auto;
            box-shadow: 0 1px 4px 0px rgb(0 0 0 / 20%);
            padding: 10px;
            border-radius: 4px;
            transition: box-shadow 0.2s linear;

            &:hover {
                box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 20%);
            }

            .photo-frame-img {
                max-width: 100%;
                height: 200px;
                background-size: cover;
                background-position: center;
            }

            .frame-meta {
                margin-top: 7px;
                display: flex;
                align-content: center;

                p {
                    color: grey;
                    margin: 0;
                }
            }

            img {
                max-width: 100%;
            }

            .frame-blurb {
                cursor: inherit;
                font-size: 1.2rem;
            }
        }
    }

</style>